import { reportInvoiceListTypes } from './types';
import { newDate } from "helpers/dateTools";

const { GET_REPORT_INVOICE_LIST, SET_REPORT_INVOICE_LIST_FILTERS, RESTORE_INITIAL } = reportInvoiceListTypes;

const initialState = {
  ReportInvoiceList: [],
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportInvoiceListReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_REPORT_INVOICE_LIST:
      return { ...state, ReportInvoiceList: payload };
    case SET_REPORT_INVOICE_LIST_FILTERS:
      return {
        ...state,
        [payload.key]: payload.value,
      };
    case RESTORE_INITIAL:
      return initialState;
    default:
      return state;
  }
};
